import React from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from './pages/Home';
import About from './pages/About';
import Project from './pages/Project';
import Media from './pages/Media';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import ProjectDetail from './components/ProjectDetail';
import Cursor from './components/Cursor';
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import Projectlib from './components/Projectlib';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/project" element={<Project />} />
        <Route path="/projects/:slug" element={<ProjectDetail />} />
        {/* <Route path="*" element={<Navigate to="/projects" />} /> */}
        <Route path="/media" element={<Media />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Cursor />
    </Router>
  );
};

export default App;
